<template>
<section class="image-slideshow px-4 py-5%">
    <div class="max-w-6xl mx-auto">
        <figure @mouseenter="freeze = true" @mouseleave="freeze = false" class="relative" :class="state">
            <div class="image-container bg-no-repeat bg-center bg-cover" :style="`background-image:url(${activeSlide.image.src})`"></div>
            <figcaption v-if="activeSlide.caption" class="caption p-4 vt:p-8 absolute left-0 bottom-0 bg-white bg-opacity-80 text-gray-800" v-html="activeSlide.caption">
            </figcaption>
        </figure>
        <div v-if="slides.length > 1" class="controls mt-4 w-full left-0 flex justify-center items-center">
            <div v-for="(slide, i) in slides" class="mx-2 flex items-center h-8">
                <button @click="goTo(i)" class="slide-button w-4 h-4 rounded-full hover:bg-accent-1" :class="activeIndex === i && state != 'sliding-out' ? 'active bg-primary-400' : 'bg-gray-500'">
                    <span class="sr-only">Go to slide {{ i + 1 }}</span>
                </button>
            </div>
        </div>
    </div>
</section>
</template>

<script>
import { ref, computed, onMounted } from 'vue';

export default {
    
    props: ['data'],

    setup(props) {

        const slides = props.data.slides;
        const state = ref('idle');
        const activeIndex = ref(0);
        const activeSlide = computed(() => slides[activeIndex.value]);
        const freeze = ref(false);

        let autoTicker = null;

        const goTo = async (i) => {
            if (autoTicker) {
                window.clearInterval(autoTicker);
                autoTicker = null;
            }
            await internalTransition(i);
            startTicker();
        };

        const internalTransition = async (i) => {
            let target = (() => {
                if (i >= slides.length) {
                    return 0;
                }
                if (i <= -1) {
                    return slides.length - 1;
                }
                return i;
            })();
            state.value = 'sliding-out';
            await window.wait(510);
            activeIndex.value = target;
            state.value = 'sliding-in';
            await window.wait(510);
            state.value = 'idle';
        };

        const startTicker = () => {
            autoTicker = window.setInterval(() => {
                if (freeze.value) {
                    return;
                }
                internalTransition(activeIndex.value + 1);
            }, 4000);
        };

        onMounted(startTicker);

        return {
            activeIndex,
            activeSlide,
            freeze,
            goTo,
            slides,
            state
        };
    }

}
</script>